function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/web.dom-collections.for-each.js";
import CartController from "./cart-controller";
export default class OfferController extends CartController {
  constructor(context) {
    super();
    this.context = void 0;
    this.cart = void 0;
    this.offers = void 0;
    this.context = context != null ? context : document;
    this.cart = this.getCart();
    this.offers = [...this.context.querySelectorAll('input[name="offer"]')];
  }

  get offerVariantId() {
    return new Promise((resolve, reject) => {
      var id = "offer-variant-id";
      var offerVariantId = this.context.querySelector("#" + id);
      offerVariantId ? resolve(offerVariantId) : reject("Failed to get the offer variant id for the dynamic checkout button, the DOM does not have an element with the id: " + id);
    });
  } // Preselects the offer in the radio group UI based on the customer's cart.


  updateCartOnPageLoad() {
    var _this = this;

    return _asyncToGenerator(function* () {
      var cart = yield _this.cart;

      var offer = _this.offers.find(o => cart.items.find(i => i.id.toString() === o.value));

      if (!offer) return;
      offer.checked = true;
    })();
  } // Shapes the variant id and quantity object to pass into the `/cart/update` endpoint.


  updateCartByOffer(offer) {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      var items = _this2.offers.reduce((i, o) => {
        Object.defineProperty(i.updates, o.value, {
          value: o === offer ? 1 : 0,
          enumerable: true
        });
        return i;
      }, {
        updates: {}
      });

      return _this2.updateItems(items);
    })();
  } // Updates the functionality for the dynamic checkout button.


  updateDynamicCheckoutButtonByOffer(offer) {
    var _this3 = this;

    return _asyncToGenerator(function* () {
      var offerVariantId = yield _this3.offerVariantId;
      offerVariantId.value = offer.value;
    })();
  } // Updates the customer's cart by interacting with the "offers" radio group.


  updateCartOnAction() {
    var _this4 = this;

    return _asyncToGenerator(function* () {
      _this4.offers.forEach(offer => offer.addEventListener("change", /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(function* (event) {
          _this4.updateCartByOffer(offer);
        });

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()));
    })();
  }

}